module.exports = __webpack_public_path__ + "static/media/clone.4eec4538.svg";